var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isValid)?_c('a',{staticClass:"flex justify-center border cursor-pointer",attrs:{"href":_vm.url,"download":"","target":"_blank","rel":"noopener"}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }